import { Icon, IconProps } from "@chakra-ui/react";

const ShieldFilled = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 20 26" {...props}>
      <path
        d="M10 25.5C7.10417 24.7708 4.71333 23.1092 2.8275 20.515C0.941667 17.9208 -0.000832781 15.0408 5.5212e-07 11.875V4.25L10 0.5L20 4.25V11.875C20 15.0417 19.0575 17.9221 17.1725 20.5163C15.2875 23.1104 12.8967 24.7717 10 25.5Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default ShieldFilled;
